import AddEmailVendor from "../../Components/Modals/AddEmailVendor";
import AddStatus from "../../Components/Modals/AddStatus";
import Table from "../../Components/Table";
import { deleteEmailVendorById, deleteStatusById, getEmailVendors, getStatus } from "../../Services/MasterService";

const EmailVendor = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    },
    {
      label: "Alias",
      value: "alias"
    },
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddEmailVendor data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getEmailVendors}
      columns={columns}
      title={"Email Vendors Master"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteEmailVendorById}
    />
  );
}

export default EmailVendor;